import { useEffect, useState } from "react";
import { addToCart, getCartCount, isInCart, loadCart } from "../services/cartService";

const getCartSnapshot = () => {
  const cart = loadCart();
  return {
    cartCount: cart.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
    cartIds: new Set(cart.map((item) => String(item.id))),
  };
};

export const useCartSnapshot = () => {
  const [snapshot, setSnapshot] = useState(() => getCartSnapshot());

  useEffect(() => {
    const syncSnapshot = () => {
      setSnapshot(getCartSnapshot());
    };

    syncSnapshot();
    window.addEventListener("storage", syncSnapshot);

    return () => {
      window.removeEventListener("storage", syncSnapshot);
    };
  }, []);

  return {
    cartCount: snapshot.cartCount,
    cartIds: snapshot.cartIds,
    syncCartSnapshot: () => setSnapshot(getCartSnapshot()),
  };
};

export const useCart = (productId) => {
  const [cartCount, setCartCount] = useState(0);
  const [inCart, setInCart] = useState(false);

  useEffect(() => {
    const syncCartState = () => {
      setCartCount(getCartCount());
      setInCart(productId ? isInCart(productId) : false);
    };

    syncCartState();
    window.addEventListener("storage", syncCartState);

    return () => {
      window.removeEventListener("storage", syncCartState);
    };
  }, [productId]);

  const add = (product) => {
    const updated = addToCart(product);
    setCartCount(updated.reduce((s, i) => s + i.quantity, 0));
    setInCart(true);
  };

  return { cartCount, inCart, add };
};
